import * as actionTypes from 'containers/PageHeader/FavoritesModal/action-types';

export const setShow = payload => ({
  type: actionTypes.SHOW,
  payload
});
